module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-change-company"
  }, [_c('modal', {
    attrs: {
      "title": "",
      "open": _vm.isOpen,
      "saveText": "Confirm"
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('auto-complete', {
    attrs: {
      "model": "organization-companies",
      "label": "Select Company",
      "placeholder": "Search...",
      "name": "value",
      "item": _vm.item,
      "autofocus": true,
      "acMinCharacters": 3
    },
    on: {
      "change": _vm.updateVal
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "open": _vm.confirmUpdateOpen,
      "title": _vm.$t('ui.contacts.modals.update.title'),
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": _vm.$t('ui.global.save')
    },
    on: {
      "save": _vm.update,
      "cancel": _vm.cancel
    }
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.$t("ui.global.update_conformation", {
    name: _vm.$tc("ui.contacts.enumeration", _vm.selected, {
      n: _vm.selected
    })
  })) + "\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0985a120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contacts/ChangeCompany.vue
// module id = 1809
// module chunks = 0